@if (jobsToUpdateCount() && count()) {
  <rt-infobox [isDismissible]="false" type="warning" iconName="warning">
    <div layout layout-space-between>
      <div layout-vertical padding-right-medium>
        <span text-bold>
          {{ 'app.offers.action_needed_infobox.title' | translate }}
        </span>
        <span>
          {{ 'app.offers.action_needed_infobox.message' | translate }}
        </span>
      </div>
      <rt-button variant="outline-warning" size="small" (click)="goToJobsToUpdateView()">
        {{ 'app.offers.action_needed_infobox.button_label' | translate }}
      </rt-button>
    </div>
  </rt-infobox>
}
